module.exports = __webpack_public_path__ + "img/cert9.f7a4beea.png";